module.exports = __webpack_public_path__ + "5b4d5c12ffa43e63e396c09fa7dfa61e.fbx";